/* eslint-disable react/prop-types */
function Minus({className, fill = "currentColor", stroke = "#000000"}) {
  return (
    <svg className={className} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill={fill} viewBox="0 0 18 2">
      <path stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h16"/>
    </svg>
  )
}

export default Minus